import { COLORS } from 'styles/constants';

const clamp = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max);

const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
  const normalized = hex?.trim();
  if (!normalized) return null;
  const match = normalized.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  if (!match) return null;
  return {
    r: parseInt(match[1], 16),
    g: parseInt(match[2], 16),
    b: parseInt(match[3], 16),
  };
};

// Returns either white or dark brown depending on background luminance
export default function getContrastingTextColor(backgroundColor: string): string {
  const rgb = hexToRgb(backgroundColor);
  if (!rgb) {
    // Fallback to white for safety when parsing fails
    return COLORS.white[100];
  }

  // Relative luminance (sRGB)
  const [rs, gs, bs] = [rgb.r, rgb.g, rgb.b].map((v) => {
    const sv = v / 255;
    return sv <= 0.03928 ? sv / 12.92 : ((sv + 0.055) / 1.055) ** 2.4;
  });
  const luminance = clamp(0.2126 * rs + 0.7152 * gs + 0.0722 * bs, 0, 1);

  // Threshold tuned so mid tones pick dark text, bright/saturated pick white
  return luminance > 0.5 ? COLORS.brown.dark[100] : COLORS.white[100];
}
